'use client'
import * as React from 'react'
import * as Dialog from 'primitives/dialog'

import { SocialShareDialogBody } from './components/social-share-dialog-body'
import { useSocialShareDialog } from '../../contexts/social-share-dialog-context'
import { useBreakpoint } from '../../../hooks/use-breakpoints'
import { Z_INDEX_MODALS } from 'constants/modals'
import { tw } from 'utils/classnames'

export function SocialShareDialog() {
  const { isOpen, closeDialog, shareUrl } = useSocialShareDialog()
  const { breakpoint } = useBreakpoint()

  const isMobile = ['xs', 'sm'].includes(breakpoint ?? '')

  return (
    <Dialog.Root open={isOpen} onOpenChange={open => !open && closeDialog()} defaultOpen={false}>
      <React.Suspense fallback={null}>
        <Dialog.Portal>
          <Dialog.Body
            className={tw(
              'font-poppins z-50 xl:overflow-y-auto px-0 md:px-[32px] lg:px-[72px] transition-transform ease-in-out duration-300',

              isOpen && isMobile ? 'opacity-100 translate-y-full' : 'opacity-50 translate-y-0',
            )}
            overlayZIndex={Z_INDEX_MODALS.authentication.react - 1}
            zIndex={Z_INDEX_MODALS.authentication.react}
            placement={isMobile ? 'bottom' : 'middle'}
          >
            <SocialShareDialogBody shareUrl={shareUrl!} />
          </Dialog.Body>
        </Dialog.Portal>
      </React.Suspense>
    </Dialog.Root>
  )
}
